import React from 'react';
import SvgIcon from './SvgIcon';

const EventCommunication = props => (
    <SvgIcon viewBox="0 0 24 22" {...props}>
        <path
            d="M6 16.5h-.181l-.14.116L.5 20.933V4A3.5 3.5 0 014 .5h16A3.5 3.5 0 0123.5 4v9a3.5 3.5 0 01-3.5 3.5H6z"
            stroke="currentColor"
        />
        <path d="M6 5h12M6 8.75h12M6 12.5h8.276" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </SvgIcon>
);

EventCommunication.displayName = 'EventCommunicationIcon';

export default EventCommunication;
